import React, { useMemo } from 'react';
import { useDepartmentsListQuery } from 'api';
import { Select, SelectProps } from 'components';

export const DepartmentSelect: React.FC<SelectProps> = React.memo((props) => {
  const { data: departmentsData = [] } = useDepartmentsListQuery();
  const options = useMemo(
    () => departmentsData?.map((_department: string) => ({ value: _department, label: _department })) || [],
    [departmentsData]
  );
  return (
    <Select
      options={options}
      showSearch
      filterOption={(input, option) => option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false}
      {...props}
    />
  );
});
